import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import LoadProfileLedger from "../LoadProfileLedger/LoadProfileLedger";
import LoadProfileRouteInfo from "../LoadProfileRouteInfo/LoadProfileRouteInfo";
import LoadProfileContacts from "../LoadProfileContacts/LoadProfileContacts";
import LoadProfilePlanningComments from "../LoadProfilePlanningComments/LoadProfilePlanningComments";

export default function LoadProfileDetailsContainer({
  activeLoad,
  activeUser,
  carrierExtraPay,
  carrierExtraPayLoading,
  stopsUpdated,
  setStopsUpdated,
  handleUpdateStops,
  handleTableAction,
  isLoading,
  clearTimeFromStops
}) {
  return (
    <Box sx={{ height: "calc(100vh - 320px)", overflow: "scroll", margin: "10px -10px 0 -10px" }}>
      <Box>
        <LoadProfilePlanningComments activeLoad={activeLoad} />
      </Box>
      <Box>
        <LoadProfileRouteInfo
          activeLoad={activeLoad}
          stopsUpdated={stopsUpdated}
          setStopsUpdated={setStopsUpdated}
          handleUpdateStops={handleUpdateStops}
          clearTimeFromStops={clearTimeFromStops}
          isLoading={isLoading}
        />
      </Box>
      <Box>
        <LoadProfileContacts
          activeLoad={activeLoad}
          handleTableAction={handleTableAction}
        />
      </Box>
      <Box>
        <LoadProfileLedger
          activeLoad={activeLoad}
          activeUser={activeUser}
          carrierExtraPay={carrierExtraPay}
          carrierExtraPayLoading={carrierExtraPayLoading}
          handleTableAction={handleTableAction}
        />
      </Box>
    </Box>
  );
}

LoadProfileDetailsContainer.propTypes = {
  activeUser: PropTypes.object.isRequired,
  activeLoad: PropTypes.object.isRequired,
  carrierExtraPay: PropTypes.array.isRequired,
  carrierExtraPayLoading: PropTypes.bool.isRequired,
  stopsUpdated: PropTypes.array,
  setStopsUpdated: PropTypes.func,
  handleUpdateStops: PropTypes.func,
  handleTableAction: PropTypes.func,
  isLoading: PropTypes.bool,
  clearTimeFromStops: PropTypes.func
};